import type { FC } from 'react';
import type { SecondaryHeroProps as Props } from './types';
import { withChildren } from '@builder.io/react';
import { cls } from '@/utils/cls';
import { TextAlignmentOptions, ImageAlignmentOptions } from '@/constants';
import { useColorProvider } from '@/utils/ColorProvider';
import style from './SecondaryHero.module.scss';
import RichText from '../RichText';
import Image from 'next/image';
const SecondaryHero: FC<Props> = ({
  extendStyles,
  heading,
  headingAlignment = TextAlignmentOptions.LEFT,
  copy,
  copyAlignment = TextAlignmentOptions.LEFT,
  imageLayout = ImageAlignmentOptions.TOP,
  line,
  image,
  color,
  textBox,
  children
}) => {
  const _className = cls(style.root, extendStyles);
  const {
    colors
  } = useColorProvider();
  return <section className={_className} style={{
    '--bgColor': color || '#F9FAFB'
  } as React.CSSProperties} data-sentry-component="SecondaryHero" data-sentry-source-file="SecondaryHero.tsx">
			<div className={style.grid} data-grid>
				<div className={textBox ? style.box : ''} style={{
        borderColor: colors.secondaryAccentColor
      }}>
					<RichText text={heading} className={!!line ? cls(style.heading, style.hr) : style.heading} style={{
          borderColor: colors.secondaryAccentColor
        }} data-align={headingAlignment} data-sentry-element="RichText" data-sentry-source-file="SecondaryHero.tsx" />
					{!!image?.src && imageLayout === ImageAlignmentOptions.TOP && <Image src={image.src} alt={image.alt || ''} role={image.alt ? undefined : 'presentation'} className={cls(style.image, style.top)} width={800} height={450} sizes="(max-width: 767px) 100vw, 50vw" />}
					<RichText text={copy} className={style.copy} data-align={copyAlignment} data-sentry-element="RichText" data-sentry-source-file="SecondaryHero.tsx" />
					{!!image?.src && imageLayout === ImageAlignmentOptions.BOTTOM && <Image src={image.src} alt={image.alt || ''} role={image.alt ? undefined : 'presentation'} className={cls(style.image, style.bottom)} width={800} height={450} sizes="(max-width: 767px) 100vw, 50vw" />}
					{children}
				</div>
			</div>
		</section>;
};
export default withChildren(SecondaryHero);